import * as React from 'react';
import { Button, InputAdornment} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { DialogTitle, Typography } from '@material-ui/core';
import BorderColorIcon from '@material-ui/icons/BorderColor';

export default function FormDialog({handleChange}) {
  const [open, setOpen] = React.useState(false);
  const [phone, setPhone] = React.useState('');
  let pn = localStorage.getItem('phone');
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPhone('');
  };

  const handleSet = () => {
    handleChange(phone)
    handleClose()
  };

  return (
    <div>
      <Typography className="text-center clickable-link" variant="body1" onClick={handleClickOpen} color='secondary'>{pn ? 'Not You?' : 'Enter Mobile Number'}&nbsp;< BorderColorIcon fontSize="medium" color="primary" className="p-1" /></Typography>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Subscribe</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Make sure to subsrcibe first in our system, before you login.<br/>
           <Typography variant="caption"> To subscribe, please Text INFO and send to 21586583 and reply YES to verify access.</Typography>
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="mobile"
            label="Mobile Number"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  +63
                </InputAdornment>
              ),
            }}
            variant="standard"
            onChange={(e) => setPhone(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={() => handleSet()}>Set</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
